import { useEffect, useRef } from "react";
import { showNotification } from "../../../../../redux/notifications/notificationsSlice";
import { useDispatch } from "react-redux";

export default function useAutoSaveBuildingDevices(
  devices,
  debouncedDevices,
  updateDeviceData,
  isEditMode
) {
  const dispatch = useDispatch();
  const lastSavedRef = useRef({});
  const isInitialized = useRef(false);

  // Initialize the stored copy only when in edit mode.
  useEffect(() => {
    if (!isEditMode) return;
    if (devices && devices.length > 0 && !isInitialized.current) {
      devices.forEach((device) => {
        if (device && device.deviceID) {
          lastSavedRef.current[device.deviceID] = { ...device };
        }
      });
      isInitialized.current = true;
    }
  }, [devices, isEditMode]);

  // Only auto-save when in edit mode.
  useEffect(() => {
    if (!isEditMode) return;
    if (!isInitialized.current) return;
    debouncedDevices.forEach((device) => {
      if (!device || !device.deviceID) return;
      const key = device.deviceID;
      // Compare only the buildingId property
      if (
        !lastSavedRef.current[key] ||
        device.buildingId !== lastSavedRef.current[key].buildingId
      ) {
        (async () => {
          try {
            await updateDeviceData(device.deviceID, device);
            lastSavedRef.current[key] = { ...device };
            dispatch(
              showNotification({
                message: "Device auto-saved.",
                type: "success",
              })
            );
          } catch (error) {
            dispatch(
              showNotification({
                message: `Auto-save failed: ${error.message}`,
                type: "error",
              })
            );
          }
        })();
      }
    });
  }, [debouncedDevices, updateDeviceData, dispatch, isEditMode]);
}
